import {
  Flex
} from "./chunk-56E2UGCA.js";
import {
  Icon
} from "./chunk-RMZQSXO2.js";
import {
  Link
} from "./chunk-UUKJNNJ5.js";
import {
  getColor
} from "./chunk-QNPCRFUV.js";

// src/components/IconWithCircleBackground.tsx
import styled from "@emotion/styled";
import { jsx } from "@emotion/react/jsx-runtime";
function IconWithCircleBackground({
  iconName = "WarningSign",
  iconWidth = 40,
  to,
  onClick,
  darkBg = false,
  shouldRotate = false
}) {
  const content = /* @__PURE__ */ jsx(Flex, { center: true, onClick, children: /* @__PURE__ */ jsx(
    StyledIconWithCircleBackground,
    {
      size: iconWidth,
      darkBg,
      shouldRotate,
      children: /* @__PURE__ */ jsx(
        Icon,
        {
          name: iconName,
          width: iconWidth,
          color: darkBg ? "white" : "grayBlue9"
        }
      )
    }
  ) });
  return to ? /* @__PURE__ */ jsx(Link, { to, children: content }) : content;
}
var StyledIconWithCircleBackground = styled.div`
  background: ${({ theme, darkBg }) => darkBg ? `linear-gradient(291.4deg, #1C243F 0%, #21283A 100%)` : getColor(theme, "grayBlue94")};
  border-radius: 50%;
  padding: ${({ size }) => getPadding(size)}px;
  display: flex;
  justify-content: center;
  ${({ size }) => `width: ${size + getPadding(size) * 2}px; height: ${size + getPadding(size) * 2}px;`}

  @keyframes IconWithCircleBackgroundRotate {
    0% {
      transform: rotate(0);
    }
    35% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  ${({ shouldRotate }) => shouldRotate && `animation: IconWithCircleBackgroundRotate 10s ease infinite;`}
`;
function getPadding(size) {
  if (size === 40) {
    return 20;
  }
  return 16;
}

export {
  IconWithCircleBackground
};
